/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import { Button, Flex, Grid, TextField } from "@aws-amplify/ui-react";
import { fetchByPath, getOverrideProps, validateField } from "./utils";
import { generateClient } from "aws-amplify/api";
import { getFeedback } from "../graphql/queries";
import { updateFeedback } from "../graphql/mutations";
const client = generateClient();
export default function FeedbackUpdateForm(props) {
  const {
    id: idProp,
    feedback: feedbackModelProp,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    ...rest
  } = props;
  const initialValues = {
    overallComment: "",
  };
  const [overallComment, setOverallComment] = React.useState(
    initialValues.overallComment
  );
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    const cleanValues = feedbackRecord
      ? { ...initialValues, ...feedbackRecord }
      : initialValues;
    setOverallComment(cleanValues.overallComment);
    setErrors({});
  };
  const [feedbackRecord, setFeedbackRecord] = React.useState(feedbackModelProp);
  React.useEffect(() => {
    const queryData = async () => {
      const record = idProp
        ? (
            await client.graphql({
              query: getFeedback.replaceAll("__typename", ""),
              variables: { id: idProp },
            })
          )?.data?.getFeedback
        : feedbackModelProp;
      setFeedbackRecord(record);
    };
    queryData();
  }, [idProp, feedbackModelProp]);
  React.useEffect(resetStateValues, [feedbackRecord]);
  const validations = {
    overallComment: [],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          overallComment: overallComment ?? null,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          await client.graphql({
            query: updateFeedback.replaceAll("__typename", ""),
            variables: {
              input: {
                id: feedbackRecord.id,
                ...modelFields,
              },
            },
          });
          if (onSuccess) {
            onSuccess(modelFields);
          }
        } catch (err) {
          if (onError) {
            const messages = err.errors.map((e) => e.message).join("\n");
            onError(modelFields, messages);
          }
        }
      }}
      {...getOverrideProps(overrides, "FeedbackUpdateForm")}
      {...rest}
    >
      <TextField
        label="Overall comment"
        isRequired={false}
        isReadOnly={false}
        value={overallComment}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              overallComment: value,
            };
            const result = onChange(modelFields);
            value = result?.overallComment ?? value;
          }
          if (errors.overallComment?.hasError) {
            runValidationTasks("overallComment", value);
          }
          setOverallComment(value);
        }}
        onBlur={() => runValidationTasks("overallComment", overallComment)}
        errorMessage={errors.overallComment?.errorMessage}
        hasError={errors.overallComment?.hasError}
        {...getOverrideProps(overrides, "overallComment")}
      ></TextField>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Reset"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          isDisabled={!(idProp || feedbackModelProp)}
          {...getOverrideProps(overrides, "ResetButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Submit"
            type="submit"
            variation="primary"
            isDisabled={
              !(idProp || feedbackModelProp) ||
              Object.values(errors).some((e) => e?.hasError)
            }
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
